<template>
  <circle-select
    v-model="selectedFont"
    :options="fontOptions"
    aria-value="font"
  >
    Ab
  </circle-select>
</template>

<script>
import CircleSelect from '../dropdown/CircleSelect.vue'
export default {
  components: {
    CircleSelect
  },
  props: {
    value: {
      type: String,
      required: true
    },
    fonts: {
      type: Array,
      default: () => [
        'Baloo Bhaina',
        'Bree Serif',
        'Bucket List',
        'Five Boroughs Handwriting',
        'Five Boroughs',
        'Futura',
        'Lato',
        'Nunito',
        'Pacifico',
        'Peytone One',
        'Russo One'
      ]
    }
  },
  computed: {
    selectedFont: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    fontOptions() {
      const fonts = this.fonts
      return fonts.map((font) => ({
        value: font,
        label: font,
        style: {
          'font-family': font
        }
      }))
    }
  }
}
</script>